import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '@/utils/cn'

const badgeVariants = cva(
  'inline-flex items-center rounded-[4px] px-1.5 py-1 transition-colors',
  {
    variants: {
      size: {
        small: 'text-caption-03-semi',
        large: 'text-caption-01-semi',
      },
      variant: {
        primary: 'bg-primary text-primary-foreground',
        red: 'bg-point-red text-white',
        orange: 'bg-point-orange-bg text-point-orange',
        blue: 'bg-point-blue-bg text-point-blue',
        purple: 'bg-point-purple-bg text-point-purple',
        pink: 'bg-point-pink-bg text-point-pink',
        green: 'bg-point-green-bg text-point-green',
        black: 'bg-black text-white',
      },
    },
    defaultVariants: {
      variant: 'orange',
      size: 'small',
    },
  },
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, size, ...props }: BadgeProps) {
  return (
    <div
      className={cn(badgeVariants({ variant, size }), className)}
      {...props}
    />
  )
}

export { Badge, badgeVariants }
